import { useState } from "react";

import { RegulatoryListData } from "@/components/business/RegulatoryContainer/Regulatory.types";
import { ProcessStatusCode } from "@/types/code.types";
import useModal from "@hooks/useModal";

import RegulatoryCheckStatusGuide from "./components/RegulatoryTableShellForRegulatoryTitle/components/RegulatoryCheckStatusGuide/RegulatoryCheckStatusGuide";
import RegulatoryTableShellForRegulatoryTitle from "./components/RegulatoryTableShellForRegulatoryTitle/RegulatoryTableShellForRegulatoryTitle";

type Props = {
  regulatoryListItem: RegulatoryListData;
  updateRegulatoryList: () => void;
};

const RegulatoryTitleContainer = ({
  updateRegulatoryList,
  regulatoryListItem,
}: Props) => {
  const [currentStatus, setCurrentStatus] = useState<ProcessStatusCode | "">(
    "",
  );

  const {
    isModal: isCheckStatusModal,
    closeModal: closeCheckStatusModal,
    openModal: openCheckStatusModal,
  } = useModal();

  const handleCurrentStatus = (status: ProcessStatusCode | "") => {
    setCurrentStatus(status);
  };

  return (
    <>
      <RegulatoryTableShellForRegulatoryTitle
        key={regulatoryListItem.id}
        regulatoryData={regulatoryListItem}
        openCheckStatusModal={openCheckStatusModal}
        handleCurrentStatus={handleCurrentStatus}
      />

      {isCheckStatusModal && (
        <RegulatoryCheckStatusGuide
          closeModal={closeCheckStatusModal}
          regulatoryData={regulatoryListItem}
          updateRegulatoryList={updateRegulatoryList}
          currentStatus={currentStatus}
        />
      )}
    </>
  );
};

export default RegulatoryTitleContainer;
